var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 4.25H34V19.8333H31.1667V7.08333H2.83333V26.9167H19.8333V29.75H0V4.25H2.83333ZM14.1667 9.91667H8.5V15.5833H14.1667V9.91667ZM5.66667 18.4167H17V24.0833H5.66667V18.4167ZM28.3333 9.91667H19.8333V12.75H28.3333V9.91667ZM19.8333 15.5833H28.3333V18.4167H19.8333V15.5833ZM24.0833 21.25H19.8333V24.0833H24.0833V21.25ZM29.75 29.75V34H26.9167V29.75H22.6667V26.9167H26.9167V22.6667H29.75V26.9167H34V29.75H29.75Z",
    fill: "#64748b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.c01527879cf3646d3d6b2d9f25c9ec37.svg";
export { ForwardRef as ReactComponent };